<template>
	<div class="myimg">
		<top-image :myimg="myimg"></top-image>
		<div class="m-person">
			<div class="wrapper-title">
				<span :class="'a' + index" v-for="(item,index) in personDetail">{{item}}</span>
			</div>
			<div class="little-title">
				<span :class="'a' + index" v-for="(item,index) in personDetaila">{{item}}</span>
			</div>
			<div class="main-word">
				<span :class="'a' + index" v-for="(item,index) in personDetailb">
					<span v-for="a in item">{{a}}</span>
				</span>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	import TopImage from 'components/top-image/top-image'

	export default {
		data() {
			return {
				myimg: 'm-person'
			}
		},
		created() {
		},
		methods: {
		},
		computed: {
			personDetail() {
				return this.$t('chaper7')
			},
			personDetaila() {
				return this.$t('charper8')
			},
			personDetailb() {
				return this.$t('charper9')
			}
		},
		components:{
			TopImage
		}
	}
</script>

<style scroped lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.m-person
		width: 80%
		margin: 80px auto
		.wrapper-title
			display: block
			.acntitle
				font-size: $font-web-medium
				color: $color-theme
			.aentitle
				font-size: $font-web-medium-s
		.little-title
			margin: 0 auto
			padding-top: 60px
			border-top: 1px solid $color-theme
			.alittletitle
				display: block
				font-size: $font-web-medium
				margin-bottom: 20px
			.aword
				display: block
				margin-bottom: 40px
		.main-word
			display: block
			.ajob
				display: block
				width: 100%
				height: 50px
				font-size: $font-web-medium
				color: $color-text
				background: $color-theme
				line-height: 50px
				padding-left: 30px
				margin-bottom: 30px
			.aPerdetail
				display: block
				margin-bottom: 20px
				span
					padding-right: 30px
					color: $color-theme
					@media screen and (max-width:550px)
						display: block
						padding: 3px 0
			.aworktitle
				display: block
				span
					display: block
					padding: 4px 0
				span:nth-child(1)
					border-bottom: 1px solid $color-text-m
</style>



// WEBPACK FOOTER //
// src/components/m-person/m-person.vue